import { render, staticRenderFns } from "./wuLiao.vue?vue&type=template&id=31fb5aee&scoped=true&"
import script from "./wuLiao.vue?vue&type=script&lang=js&"
export * from "./wuLiao.vue?vue&type=script&lang=js&"
import style0 from "./wuLiao.vue?vue&type=style&index=0&id=31fb5aee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb5aee",
  null
  
)

export default component.exports